import React from "react";
import {Tooltip} from "@material-ui/core";
import {SearchResultDataPropertyType} from "../../../../helpers/productHelper";
import {DEFAULT_TOOLTIP_PROPS} from "../../../../helpers/tooltipHelper";

interface PropsType {
  properties: SearchResultDataPropertyType[],
  isListViewActive: boolean
}

const SearchResultDataProperties = (props: PropsType) => {
  const {
    properties,
    isListViewActive
  } = props;

  return (
    <>
      {properties.map((column) => (
        <p
          key={`search-result-data-property-${column.label}`}
          className="search-result-data-property"
        >
          <span className="name">{column.label}</span>
          <Tooltip
            {...DEFAULT_TOOLTIP_PROPS}
            placement={isListViewActive ? "bottom" : "right"}
            title={column.value}
          >
            <span className="value">
              {column.html ? column.html : column.value}
            </span>
          </Tooltip>
          <span className="extra">
            {
              column.extra ? column.extra : null
            }
          </span>
        </p>
      ))}
    </>
  )
};

export default SearchResultDataProperties;
